import React, { Component, PureComponent, Fragment } from 'react';
import Modal from 'react-modal';
import { ModalContainer } from 'APP_ROOT/components/common/Modal2';
import PropTypes, { string } from 'prop-types';

import { OTSession, OTSubscriber, preloadScript } from 'opentok-react';
import AgoraRTC from 'agora-rtc-sdk-ng';

import {EVENT_MEDIA_CAMERA_TYPE} from '../EventMedia/eventMediaConstants';
import EventMediaControl from '../EventMedia/EventMediaControl';
import imageCamToggle from '../EventMedia/images/cam-toggle-w64.svg';
import imageDownload from '../EventMedia/images/download-w64.svg';
import imagePauseToggle from '../EventMedia/images/pause-toggle-w64.svg';
import imageSkipBackward from '../EventMedia/images/skip-backward-w64.svg';
import imageSkipForward from '../EventMedia/images/skip-forward-w64.svg';

import imageFullscreen from '../EventMedia/images/fullscreen-w64.svg';
import { requestEventMediaFullscreen } from '../EventMedia/EventMedia';

import Events from '../../../common/events';

import LambdaUtil from '../../../aws/lambda/lambdaUtil';
import { ModalLoadingPage } from '../../../common/loadingPage';
import { strings } from '../../../../localization';

import { RcAPI } from '../../../common/rcApi';
import ProgressOverlay from 'APP_ROOT/components/common/ProgressOverlay';
import webappStreamToDownloadRequestSuccessWireframeSrc from './images/webapp_stream_to_download_request_success-wireframe.png';

const SEEK_INTERVAL_S = 15;
const PLAYBACK_REQUEST_TIMEOUT = 2000;
const HISTORICAL_STREAMING_STARTTIMESTAMP_ADJUSTMENT = 5;
const FRESH_SESSION_RETRY_TIMEOUT = 8000; // 8 seconds

let previousSessionId = null;


class OTStreamWrapper extends Component {

    fullscreenElementRef = React.createRef();

    constructor() {
        super();
    
        this.seenStream = false;
    }

    getChildContext() {
        return { 
                stream: this.context.streams[0],
                session: this.context.session
            };
    }

    doRetry = (e) => {
        e.preventDefault();

        this.seenStream=false;

        this.props.onRetry();
    }
    

    render() {

        if(this.context.streams && this.context.streams.length)
        {
            this.seenStream = true;
        }

        var dotClassNames = "recording";
        if(this.props.timedOut) dotClassNames += " countdown";

        return (
                <div className="event-media-wrapper-16-9-aspect-ratio" ref={this.fullscreenElementRef}>
                    <div className="event-media-wrapper">
                        { 
                        this.context.streams && this.context.streams.length > 0 ?

                            <Fragment>
                              <OTSubscriber 
                                  stream={this.context.streams[0]}
                                  session={this.context.session}
                                  properties={{
                                    subscribeToAudio: true,
                                    subscribeToVideo: true,
                                    preferredResolution: "1280x720",
                                    preferredFrameRate: 30,
                                    insertMode: "append",
                                    width: "100%",
                                    height: "inherit"
                                  }} 
                                    onError={this.props.onError}                                    
                                />
                              <div className="event-media-decoration">
                                  <div className={dotClassNames}>
                                      <span className="blinking-dot"></span>
                                      <svg>
                                        <circle r="10.2375" cx="11.375" cy="11.375"></circle>
                                      </svg>
                                  </div>
                              </div>


                              <div className="event-media-controls">
                                {this.props.shouldShowPlaybackControls ?
                                    <>
                                        <div className="event-media-control-empty-placeholder"></div>
                                        <div className="playback-controls-group">
                                            <EventMediaControl
                                                iconSrc={imageSkipBackward}
                                                render={true}
                                                pending={this.props.skipBackwardEnabled ? false : true }
                                                onClick={this.props.onSkipBackward}
                                            >
                                                {SEEK_INTERVAL_S}
                                            </EventMediaControl>
                                        <EventMediaControl
                                                iconSrc={imagePauseToggle}
                                                render={true}
                                                pending={this.props.pauseToggleEnabled ? false : true }
                                                onClick={this.props.onPauseToggle}
                                            />
                                        <div className={this.props.streamInferredPlaybackStatePlaying === undefined || !this.props.downloadMediaControlIsVisible ? "playback-control-wrapper collapsed" : "playback-control-wrapper"}>
                                            <EventMediaControl
                                                iconSrc={imageDownload}
                                                render={true}
                                                pending={this.props.pauseToggleEnabled ? false : true }
                                                onClick={this.props.onClickDownload}
                                            />
                                        </div>
                                        <EventMediaControl
                                                iconSrc={imageSkipForward}
                                                render={true}
                                                pending={this.props.skipForwardEnabled ? false : true }
                                                onClick={this.props.onSkipForward}
                                            >
                                                {SEEK_INTERVAL_S}
                                            </EventMediaControl>
                                        </div>
                                    </>
                                : null }
                                <EventMediaControl
                                    iconSrc={imageFullscreen}
                                    render={true}
                                    onClick={() => {requestEventMediaFullscreen(this.fullscreenElementRef)}}
                                />
                                <EventMediaControl
                                    iconSrc={imageCamToggle}
                                    render={true}
                                    pending={this.props.switchCameraEnabled ? false : true }
                                    onClick={this.props.switchCamera}
                                />
                              </div>
                            </Fragment>
                        : this.seenStream ?
                            <div className="pause-overlay">
                                <div>
                                    <h2>{strings.streaming_session_ended_title}</h2>
                                    <p><a href="#" onClick={this.doRetry}>{strings.streaming_session_click_here_to_reconnect}</a></p>
                                </div>
                            </div> : 
                            <div className="loading-overlay"> <ModalLoadingPage message={strings.streaming_session_connecting} /> </div>
                        }
                    </div>
                </div>

        );
    }
}

OTStreamWrapper.propTypes = {
  streams: PropTypes.arrayOf(PropTypes.object),
  session: PropTypes.shape({ publish: PropTypes.func, subscribe: PropTypes.func }),
};

OTStreamWrapper.contextTypes = {
  streams: PropTypes.arrayOf(PropTypes.object),
  session: PropTypes.shape({ subscribe: PropTypes.func, unsubscribe: PropTypes.func }),
};

OTStreamWrapper.childContextTypes = {
  session: PropTypes.shape({ subscribe: PropTypes.func, unsubscribe: PropTypes.func }),
  stream: PropTypes.shape({
    streamId: PropTypes.string,
  }),
};

class AgoraStream extends Component {
    
    fullscreenElementRef = React.createRef();
    
    constructor(props) {
        super(props);
        this.connecting = false;
        this.client = null;
    }

    state = {
        ready: false,
        playing: false
    }

    setupAudience = async () => {
        if(this.connecting) return;
        
        this.connecting = true;

        AgoraRTC.setLogLevel(3); // 0: DEBUG, 1: INFO, 2: WARNING, 3: ERROR, 4: NONE (https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/iagorartc.html#setloglevel)

        this.client = AgoraRTC.createClient({ mode: 'rtc', codec: 'h264'});

        this.client.on('user-published', this.onUserPublished);

        this.client.on("user-unpublished", this.onUserUnpublished);

        this.client.on("stream-message", this.onStreamMessage);

        this.connect();        
    }

    connect = async () => {
        await this.client.join(this.props.apiKey, this.props.sessionId, this.props.token, parseInt(this.props.uid));

        this.connecting = false;
        this.setState({ready: true});

        this.props.setAgoraSession(this.client);
        this.props.eventHandlers.sessionConnected({target: {disconnect: this.disconnect}});
    }

    disconnect = async () => {
        if(this.client && this.client.leave) {

            this.client.off('user-published', this.onUserPublished);
            this.client.off("user-unpublished", this.onUserUnpublished);
            this.client.off("stream-message", this.onStreamMessage);

            await this.client.leave();

            this.client = null;            
            this.props.eventHandlers.sessionDisconnected();            
            this.props.setAgoraSession(null);
        }
    }

    onUserPublished = async (user, mediaType) => {

        await this.client.subscribe(user, mediaType);

        this.props.eventHandlers.streamCreated({stream: {name: "Raven"}});

        if (mediaType === 'video') {
            const streamWrapper = document.querySelector('.agora-stream');
            const player = document.createElement('div');
            player.id = `player_${user.uid}`;
            player.style.width = '100%';
            player.style.height = 'inherit';

            streamWrapper.append(player);
            
            user.videoTrack.play(`player_${user.uid}`, { fit: 'cover' });
        }

        if (mediaType === 'audio') {
            user.audioTrack.play();
        }

        this.setState({playing: true});
    }

    onUserUnpublished = () => {
        this.setState({playing: false});
        const streamWrapper = document.querySelector('.agora-stream');
        streamWrapper.innerHTML = '';
    }

    onStreamMessage = (uid, payload) => {
        const message = this.parseAgoraMessage(payload);
        
        if(message === "ping"){
            this.props.eventHandlers['signal:ping']();
        }
    }

    componentDidMount() {
        if (!this.state.ready && !this.connecting) {
            this.setupAudience();
        }
    }

    componentDidUpdate() {
        if (!this.state.ready && !this.connecting) {
            this.setupAudience();
        }
    }

    componentWillUnmount() {
        this.disconnect();
    }

    parseAgoraMessage(payload) {

        if(!payload) {
            return '';
        }

        const asciiCodes = Object.values(payload);
        return asciiCodes.map((code) => String.fromCharCode(code)).join('');
    }

    render() {
        let dotClassNames = "recording";
        if(this.props.timedOut) dotClassNames += " countdown";

        return (
            <div className="event-media-wrapper-16-9-aspect-ratio" ref={this.fullscreenElementRef}>
                <div className="event-media-wrapper">
                    <div className="agora-stream text-center overflow-hidden">
                        {this.connecting && <div className="loading-overlay"> <ModalLoadingPage message={strings.streaming_session_connecting} /> </div>}
                        {this.state.ready && !this.state.playing && <div className="loading-overlay"> <ModalLoadingPage message={strings.streaming_session_connecting} /> </div>}
                    </div>

                    {this.state.playing &&
                    <>
                        <div className="event-media-decoration">
                            <div className={dotClassNames}>
                                <span className="blinking-dot"></span>
                                <svg>
                                <circle r="10.2375" cx="11.375" cy="11.375"></circle>
                                </svg>
                            </div>
                        </div>

                        <div className="event-media-controls">
                            {this.props.shouldShowPlaybackControls ?
                                <>
                                    <div className="event-media-control-empty-placeholder"></div>
                                    <div className="playback-controls-group">
                                        <EventMediaControl
                                            iconSrc={imageSkipBackward}
                                            render={true}
                                            pending={this.props.skipBackwardEnabled ? false : true }
                                            onClick={this.props.onSkipBackward}
                                        >
                                            {SEEK_INTERVAL_S}
                                        </EventMediaControl>
                                    <EventMediaControl
                                            iconSrc={imagePauseToggle}
                                            render={true}
                                            pending={this.props.pauseToggleEnabled ? false : true }
                                            onClick={this.props.onPauseToggle}
                                        />
                                    <div className={this.props.streamInferredPlaybackStatePlaying === undefined || !this.props.downloadMediaControlIsVisible ? "playback-control-wrapper collapsed" : "playback-control-wrapper"}>
                                        <EventMediaControl
                                            iconSrc={imageDownload}
                                            render={true}
                                            pending={this.props.pauseToggleEnabled ? false : true }
                                            onClick={this.props.onClickDownload}
                                        />
                                    </div>
                                    <EventMediaControl
                                            iconSrc={imageSkipForward}
                                            render={true}
                                            pending={this.props.skipForwardEnabled ? false : true }
                                            onClick={this.props.onSkipForward}
                                        >
                                            {SEEK_INTERVAL_S}
                                        </EventMediaControl>
                                    </div>
                                </>
                            : null }
                                
                            <EventMediaControl
                                iconSrc={imageFullscreen}
                                render={true}
                                onClick={() => {requestEventMediaFullscreen(this.fullscreenElementRef)}}
                            />
                            <EventMediaControl
                                iconSrc={imageCamToggle}
                                render={true}
                                pending={this.props.switchCameraEnabled ? false : true }
                                onClick={this.props.switchCamera}
                            />
                        </div>
                    </>
                    }
                </div>
            </div>
        )
    }
}

class LiveStream extends PureComponent {

    constructor(props) {

        super(props);

        var me = this;

        this.state = {
            modalContainer: null,
            connected: false,
            errorMessage: null,
            timedOut: false,
            switchCameraEnabled: true,
            pauseToggleEnabled: true,
            skipBackwardEnabled: true,
            skipForwardEnabled: true,
            downloadMediaControlIsVisible: false,
        }

        // in lieu of RAV-2580, playback state and the playhead timestamp needs to be inferred or assumed
        this.streamInferredPlaybackStatePlaying = undefined; // assumed to be playing on connect
        this.streamInferredPlayheadTimestamp = 0; // default (0) is live streaming, updated while user pauses, skips forward/backward
        this.streamInferredCameraIsRoad = undefined; // toggled between road/camera on toggle events

        this.startStreamTimeout = undefined;
        this.killStreamTimeout = undefined;
        this.cameraSwitchTimeout = undefined;
        this.pauseToggleTimeout = undefined;
        this.downloadAutoHideTimeout = undefined;
        this.skipBackwardTimeout = undefined;
        this.skipForwardTimeout = undefined;
        this.waitRavenTimeout = undefined;
        this.freshSessionRetryTimeout = undefined;

        this.hasRetriedForAFreshSession = false;

        this.streamInferredPlayheadTimestampInterval = undefined;

        this.sessionEvents = {
          sessionConnected: (e) => {
            this.setState({ 
                connected: true,
                sessionKilled: false,
                sessionObject: e
            });
          },
          sessionDisconnected: (e) => {
            this.setState({ connected: false });
          },
          streamCreated: (e) => {

            this.setState({
                streamConnected: true,
            });

            if(e && e.stream && e.stream.name && e.stream.name.contains("Raven"))
            {
                if(this.waitRavenTimeout) {
                    clearTimeout(this.waitRavenTimeout);
                    if (this.streamInferredPlaybackStatePlaying === undefined) {
                        this.streamInferredPlaybackStatePlaying = true;
                        this.startStreamInferredPlayheadTimestampInterval();
                    }
                }
            }
          },
          'signal:ping': (e) => {
                if (this.waitRavenTimeout) {
                    clearTimeout(this.waitRavenTimeout);
                }
                this.sendPong(e);
          },
          'signal:cameraset': (e) => {
                if(this.waitRavenTimeout)
                    clearTimeout(this.waitRavenTimeout);
                if(this.cameraSwitchTimeout)
                    clearTimeout(this.cameraSwitchTimeout);

                this.cameraSwitchTimeout = setTimeout(() => {
                    me.setState({switchCameraEnabled: true});
                }, 1000); // 1 second timeout as it is too soon.
          },
        };

        this.otSession = React.createRef();
        this.agoraSession = React.createRef();

        document.addEventListener(Events.PAUSE_DFAST, this.onAppPauseEvent); 
        document.addEventListener(Events.UNPAUSE_DFAST, this.onAppResumeEvent);
    }

    setAgoraSession = (client) => {
        this.agoraSession.current = client;
    }

    sendMessageToAgora = (message, toBeCalledAfterMessageSent) => {
        const agoraSession = this.agoraSession.current;        

        if(agoraSession){
            try{
                agoraSession.sendStreamMessage(JSON.stringify(message));
                if(toBeCalledAfterMessageSent) toBeCalledAfterMessageSent();
            } catch (error) {
                console.error('Agora messaging: Failed to send the message', error);
            }
        }
        else{
            console.error("Agora messaging: Agora session not found", message);
        }
    }

    startStreamInferredPlayheadTimestampInterval = () => {
        if (this.streamInferredPlayheadTimestamp) { // check if 0, basically; 0 is live streaming and playhead timestamp is not used
            clearInterval(this.streamInferredPlayheadTimestampInterval);
            this.streamInferredPlayheadTimestampInterval = setInterval(() => {
                this.streamInferredPlayheadTimestamp += 1;
            }, 1000);
        }
    }

    errorOnTimeout = (errorString) => {

        clearInterval(this.streamInferredPlayheadTimestampInterval);
        this.streamInferredPlaybackStatePlaying = undefined; // used as a flag on stream start

        if(this.state.sessionObject && this.state.sessionObject.target)
            this.state.sessionObject.target.disconnect();

        if(errorString)
        {
            this.setState({
                apiKey: null,
                sessionId: null,
                token: null,
                sessionObject: null,
                error: errorString,
                sessionKilled: true
            });
        }
        else
        {
            this.setState({
                apiKey: null,
                sessionId: null,
                token: null,
                sessionObject: null,
                sessionKilled: true
            });
        }
    }

    sendPong = (e) => {
        
        const message = {
            type: 'ping', 
            to: e ? e.from : null, 
            data: 'pong'
        };

        if(this.state.provider === "agora"){
            this.sendMessageToAgora(message);
            return;
        }

        if(this.otSession && 
            this.otSession.current && 
            this.otSession.current.sessionHelper &&
            this.otSession.current.sessionHelper.session)
        {
            this.otSession.current.sessionHelper.session.signal( message , (e) => { /* Check for error (non-null e) */ } );
        }
    }

    sendSeekRelative (signedSeconds) {

        const message = {type: 'seekrelative', data: String(signedSeconds)};

        const afterSendSeekRelative = () => {
            this.streamInferredPlayheadTimestamp = this.streamInferredPlayheadTimestamp + signedSeconds;
        }


        if(this.state.provider === "agora"){
            this.sendMessageToAgora(message, afterSendSeekRelative);
            return;
        }

        if (this.otSession && 
            this.otSession.current && 
            this.otSession.current.sessionHelper &&
            this.otSession.current.sessionHelper.session) {

            this.otSession.current.sessionHelper.session.signal(message);

            afterSendSeekRelative();
        }
    }

    onSkipForward = () => {

        this.sendSeekRelative(SEEK_INTERVAL_S);

        this.setState({skipForwardEnabled: false});
        clearTimeout(this.skipForwardTimeout);
        this.skipForwardTimeout = setTimeout(() => {
            this.setState({skipForwardEnabled: true});
        }, PLAYBACK_REQUEST_TIMEOUT); // 4 second timeout for camera switch

    }

    onSkipBackward = () => {

        this.sendSeekRelative(parseInt(SEEK_INTERVAL_S) * (-1));

        this.setState({skipBackwardEnabled: false});
        clearTimeout(this.skipBackwardTimeout);
        this.skipBackwardTimeout = setTimeout(() => {
            this.setState({skipBackwardEnabled: true});
        }, PLAYBACK_REQUEST_TIMEOUT); // 4 second timeout for camera switch
    }

    sendPauseToggle = () => {

        const message = {type: 'pause', data: "toggle"};

        const afterPauseToggle = () => {            
            this.setState({pauseToggleEnabled: false});
            clearTimeout(this.pauseToggleTimeout);
            this.streamInferredPlaybackStatePlaying = this.streamInferredPlaybackStatePlaying === undefined || !this.streamInferredPlaybackStatePlaying ? true : false;
            this.pauseToggleTimeout = setTimeout(() => {
                this.setState({
                    pauseToggleEnabled: true
                });
            }, PLAYBACK_REQUEST_TIMEOUT); // 4 second timeout for camera switch

            // auto-hide historical streaming download media control after a 5 second delay during unpause events
            clearTimeout(this.downloadAutoHideTimeout);
            if (!this.streamInferredPlaybackStatePlaying) {
                clearInterval(this.streamInferredPlayheadTimestampInterval);
                this.setState({downloadMediaControlIsVisible: true});
            } else {
                this.startStreamInferredPlayheadTimestampInterval();
                this.downloadAutoHideTimeout = setTimeout(() => {
                    this.setState({downloadMediaControlIsVisible: false});
                }, 5000);
            }
        }

        if(this.state.provider === "agora"){
            this.sendMessageToAgora(message, afterPauseToggle);

            return;
        }

        if (this.otSession && 
            this.otSession.current && 
            this.otSession.current.sessionHelper &&
            this.otSession.current.sessionHelper.session) {

            this.otSession.current.sessionHelper.session.signal(message); // Raven supports "toggle", "0", "false", "1", "true"

            afterPauseToggle();
        }
    }

    onClickDownload = () => {

        const dismissModalContainer = () => {
            this.setState({modalContainer: null});
        }

        const onSuccess = () => {
            this.setState({
                modalContainer: (
                    <ModalContainer
                        title={strings.streaming_request_video_download_success_header}
                        smallDialogMode={false}
                        fillToMaxHeightPixels={490}
                        onClickClose={dismissModalContainer}
                    >
                        <div className="message">
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                                alignItems: "center"
                            }}>
                                <div style={{
                                    flexShrink: "1",
                                    minHeight: "0"
                                }}>
                                    <img src={webappStreamToDownloadRequestSuccessWireframeSrc} alt=""/>
                                </div>
                                <div style={{
                                    flexShrink: "0",
                                    padding: "10px 0 0 0"
                                }}>
                                    {strings.streaming_request_video_download_success_description}
                                </div>
                            </div>
                        </div>

                        <div className="actions">
                            <button onClick={dismissModalContainer} >{strings.app_ok}</button>
                        </div>
                    </ModalContainer>
                )
            });    
        }

        const onError = () => {
            this.setState({
                modalContainer: (
                    <ModalContainer
                        title={strings.streaming_request_video_download_error_header}
                        smallDialogMode={true}
                        onClickClose={dismissModalContainer}
                    >
                        <div className="message">
                            {strings.streaming_request_video_download_error_description}
                        </div>

                        <div className="actions">
                            <button onClick={dismissModalContainer} >{strings.app_ok}</button>
                        </div>
                    </ModalContainer>
                )
            });    
        }

        this.setState({
            modalContainer: (
                <ModalContainer
                    title={strings.streaming_request_video_download_header}
                    smallDialogMode={true}
                    onClickClose={dismissModalContainer}
                >
                    <LiveStreamDownload
                        stage={this.props.stage}
                        ravenUuid={this.props.ravenUuid}
                        cameraType={this.streamInferredCameraIsRoad ? "ROAD" : "CABIN"}
                        timestamp={this.streamInferredPlayheadTimestamp}
                        onCancel={dismissModalContainer}
                        onError={onError}
                        onSuccess={onSuccess}
                    />
                </ModalContainer>
            )
        });
    }

    switchCamera = (cameraid) =>
    {

        var me = this;
        
        const message = {type: 'camera', data: "switch"}; 
        
        const afterSwitchCamera = () => {
            this.setState({switchCameraEnabled: false});
            clearTimeout(this.cameraSwitchTimeout);
            this.cameraSwitchTimeout = setTimeout(() => {
                me.setState({switchCameraEnabled: true});
            }, PLAYBACK_REQUEST_TIMEOUT); // 4 second timeout for camera switch
            this.streamInferredCameraIsRoad = this.streamInferredCameraIsRoad !== undefined ? !this.streamInferredCameraIsRoad : undefined;
        }

        if(this.state.provider === "agora"){
            this.sendMessageToAgora(message, afterSwitchCamera);

            return;
        }

        if(this.otSession.current.sessionHelper && this.otSession.current.sessionHelper.session)
        {
            this.otSession.current.sessionHelper.session.signal({type: 'camera', data: "switch"}, (e) => { /* Check for success (non-null e) */ } );
            afterSwitchCamera();
        }
    }

    onError = (err) => {
        this.setState({ errorMessage: `Failed to connect: ${err.message}` });
    }

    componentDidMount() {

        document.documentElement.classList.add("no-scroll");

        this.onStartStreaming();
    }

    componentWillUnmount() {

        clearTimeout(this.cameraSwitchTimeout);
        clearTimeout(this.pauseToggleTimeout);
        clearTimeout(this.skipBackwardTimeout);
        clearTimeout(this.skipForwardTimeout);
        clearTimeout(this.startStreamTimeout);
        clearTimeout(this.killStreamTimeout);
        clearTimeout(this.downloadAutoHideTimeout);
        clearTimeout(this.waitRavenTimeout);
        clearTimeout(this.freshSessionRetryTimeout);
        clearInterval(this.streamInferredPlayheadTimestampInterval);

        document.documentElement.classList.remove("no-scroll");

        document.removeEventListener(Events.PAUSE_DFAST, this.onAppPauseEvent); 
        document.removeEventListener(Events.UNPAUSE_DFAST, this.onAppResumeEvent); 
    }

    onAppPauseEvent = () => {
        // DFasts are no longer being sent, start a 1 minute timer to kill the connection

        this.setState({timedOut: true});

        var me = this;

        if(!this.killStreamTimeout && this.state.sessionObject && this.state.sessionObject.target)
        {
            this.killStreamTimeout = setTimeout(function() {
                me.errorOnTimeout();
            }, 1000 * 45); // 45 seconds
        }
    }

    onAppResumeEvent = () => {

        clearTimeout(this.killStreamTimeout);
        this.killStreamTimeout = undefined;

        this.setState({timedOut: false});
        this.sendPong();
    }

    onStartStreaming = (resume = false) => {

        // 1. Reset: cancel in-flight timers, reset stale UI state
        clearTimeout(this.startStreamTimeout);
        clearTimeout(this.waitRavenTimeout);
        clearTimeout(this.freshSessionRetryTimeout);
        this.setState({
            modalLoading: true,
            errorMessage: null,
        });

        // 2. Compute params
        let eventTimestamp;
        if (this.props.startDate) {
            eventTimestamp = Math.floor(this.props.startDate.getTime()/1000);

            if(this.streamInferredPlayheadTimestamp === 0 || !resume) {
                // Start from the beginning of the stream
                this.streamInferredPlayheadTimestamp = eventTimestamp - HISTORICAL_STREAMING_STARTTIMESTAMP_ADJUSTMENT; // subtract 5 seconds as per QA feedback
            }
            else{
                // Resume from where the stream disconnected
                // this.streamInferredPlayheadTimestamp = this.streamInferredPlayheadTimestamp - HISTORICAL_STREAMING_STARTTIMESTAMP_ADJUSTMENT; // subtract 5 seconds as per QA feedback
            }
        }
        let cameraType = "1";
        this.streamInferredCameraIsRoad = true;
        if (this.props.defaultCamera !== EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
            cameraType = "2";
            this.streamInferredCameraIsRoad = false;
        }
        
        // 3. Initiate new stream request
        LambdaUtil.createStreamingToken(this.props.stage, this.props.ravenUuid, this.streamInferredPlayheadTimestamp, cameraType, eventTimestamp, this.onStartStreamingSuccess, this.onStartStreamingError);
        
        this.startStreamTimeout = setTimeout(() => {
            this.onStartStreamingError();
        }, 10000);
    }

    onRetry = () => {
        this.hasRetriedForAFreshSession = false;
        this.onStartStreaming();
    }

    onResume = () => {
        this.hasRetriedForAFreshSession = false;
        this.onStartStreaming(true);
    }

    shouldRetryForAFreshSession = (receivedSessionId) => {
        const isStaleSession = previousSessionId !== null && receivedSessionId === previousSessionId;

        previousSessionId = receivedSessionId;

        return isStaleSession && !this.hasRetriedForAFreshSession;
    }

    retryAFreshSession = () => {
        clearTimeout(this.freshSessionRetryTimeout);
        this.freshSessionRetryTimeout = setTimeout(() => {
            this.hasRetriedForAFreshSession = true;
            this.onStartStreaming();
        }, FRESH_SESSION_RETRY_TIMEOUT);
    }

    onStartStreamingSuccess = (response) => {
        clearTimeout(this.startStreamTimeout);

        try {
            var payload = JSON.parse(response.Payload);
            if (payload.status === "ERROR") {
                console.error(response);
                this.setState({
                    modalLoading: false,
                    errorMessage: strings.formatString(strings.ts_send_error)
                });
            } else {                
                
                const shouldRetryForAFreshSession = this.shouldRetryForAFreshSession(payload?.response?.sessionId);                

                if (shouldRetryForAFreshSession) {
                    this.retryAFreshSession();
                    return;
                }

                this.setState({
                    modalLoading: false,
                    apiKey: payload.response.apiKey,
                    sessionId: payload.response.sessionId,
                    token: payload.response.token,
                    provider: payload.response.provider ? payload.response.provider : "tokbox",
                    uid: payload.response.uid,
                    errorMessage: null,
                });

                clearTimeout(this.waitRavenTimeout);
                this.waitRavenTimeout = setTimeout( () => {
                    this.errorOnTimeout(strings.formatString(strings.streaming_error_timeout_waiting_for_stream));
                }, 15000);

            }
        } catch (e) {
            console.error('Unable to get stream information', e);
            this.setState({
                modalLoading: false,
            });
        }
    }

    onStartStreamingError = (response) => {

        this.setState({
            modalLoading: false,
            errorMessage: strings.formatString(strings.streaming_error_timeout_create_token)
        });
    }

    renderTokBoxStream = (shouldShowPlaybackControls) => {
        return (
            <OTSession
                ref={this.otSession}
                apiKey={this.state.apiKey}
                sessionId={this.state.sessionId}
                token={this.state.token}
                eventHandlers={this.sessionEvents}
                onError={this.onError}
                >
                    <OTStreamWrapper
                        shouldShowPlaybackControls={shouldShowPlaybackControls}
                        streamInferredPlaybackStatePlaying={this.streamInferredPlaybackStatePlaying}
                        onError={this.onError}
                        switchCamera={this.switchCamera}
                        switchCameraEnabled={this.state.switchCameraEnabled}
                        onPauseToggle={this.sendPauseToggle}
                        onClickDownload={this.onClickDownload}
                        pauseToggleEnabled={this.state.pauseToggleEnabled}
                        downloadMediaControlIsVisible={this.state.downloadMediaControlIsVisible}
                        onSkipBackward={this.onSkipBackward}
                        onSkipForward={this.onSkipForward}
                        skipBackwardEnabled={this.state.skipBackwardEnabled}
                        skipForwardEnabled={this.state.skipForwardEnabled}
                        onRetry={this.onRetry}
                        timedOut={this.state.timedOut}
                    />
            </OTSession>
        )
    }

    renderAgoraStream = (shouldShowPlaybackControls) => {
        return (
            <AgoraStream
                shouldShowPlaybackControls={shouldShowPlaybackControls}
                streamInferredPlaybackStatePlaying={this.streamInferredPlaybackStatePlaying}
                onPauseToggle={this.sendPauseToggle}
                onClickDownload={this.onClickDownload}
                pauseToggleEnabled={this.state.pauseToggleEnabled}
                downloadMediaControlIsVisible={this.state.downloadMediaControlIsVisible}
                onSkipBackward={this.onSkipBackward}
                onSkipForward={this.onSkipForward}
                skipBackwardEnabled={this.state.skipBackwardEnabled}
                skipForwardEnabled={this.state.skipForwardEnabled}
                onRetry={this.onRetry}
                switchCameraEnabled={this.state.switchCameraEnabled}
                switchCamera={this.switchCamera}
                setAgoraSession={this.setAgoraSession}
                onError={this.onError}
                apiKey={this.state.apiKey}
                sessionId={this.state.sessionId}
                token={this.state.token}
                eventHandlers={this.sessionEvents}
                timedOut={this.state.timedOut}
                uid={this.state.uid}
            />
        )
    }

    renderReconnectionControls = (shouldShowResumeAndRestartButtons) => {
        return (
            <div className="event-media-wrapper-16-9-aspect-ratio">
                <div className="event-media-wrapper">
                    <div className="pause-overlay">
                        {this.state.streamConnected ? (
                            <div>
                                <h2>{strings.streaming_session_ended_title}</h2>
                                {shouldShowResumeAndRestartButtons ? (
                                    <>
                                        {/* If it's a historic stream, show Resume and Restart buttons if stream disconnects*/}
                                        <p><a href="#" onClick={this.onResume}>{strings.streaming_session_click_here_to_resume}</a></p>
                                        <p><a href="#" onClick={this.onRetry}>{strings.streaming_session_click_here_to_restart}</a></p>
                                    </>
                                ) : (
                                    <p><a href="#" onClick={this.onRetry}>{strings.streaming_session_click_here_to_reconnect}</a></p>
                                )}
                            </div>
                        ) : (
                            <div>
                                <h2>{strings.streaming_session_timeout_message}</h2>
                                <p><a href="#" onClick={this.onRetry}>{strings.streaming_session_timeout_click_here_to_retry}</a></p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    renderModalLoading = (hadPreviousStream) => {
        const spinner = <ModalLoadingPage message={strings.streaming_waiting_for_raven_to_connect_message} />;

        if (hadPreviousStream) {
            // Show "waiting" but Preserve full-size frame during reconnect
            return (
                <div className="event-media-wrapper-16-9-aspect-ratio">
                    <div className="event-media-wrapper">
                        <div className="loading-overlay">{spinner}</div>
                    </div>
                </div>
            );
        }

        return spinner;
    }

    render() {
        let shouldShowPlaybackControls = false; // playback pause and seek controls not supported for live streams
        let shouldShowResumeAndRestartButtons = false;

        const isStreaming = !this.state.modalLoading && this.state.apiKey;
        const hadPreviousStream = this.state.streamConnected || this.state.sessionKilled;
        const showReconnectControls = hadPreviousStream && !this.state.modalLoading;

        if (this.props.startDate) { // historical streams have startDates
            shouldShowPlaybackControls = true;
            shouldShowResumeAndRestartButtons = true;
        }
        
        return (
                <Modal
                    className="react-modal-content react-modal-sm live-stream"
                    isOpen={true}
                    contentLabel="trip-sharing-modal"
                    overlayClassName="react-modal-overlay"
                    shouldCloseOnOverlayClick={false}
                    onRequestClose={this.props.onClose}
                >

                    <div 
                        className="container-fluid"
                        style={{width: "90vw"}}
                    >
                        <div className="row">
                            <div className="col-12 stream">
                            {isStreaming ?
                                <>
                                {this.state.provider === "tokbox" &&  this.renderTokBoxStream(shouldShowPlaybackControls)}
                                {this.state.provider === "agora" &&  this.renderAgoraStream(shouldShowPlaybackControls)}
                                </>
                            :
                                showReconnectControls ?
                                    this.renderReconnectionControls(shouldShowResumeAndRestartButtons)
                                : 
                                    this.renderModalLoading(hadPreviousStream)
                            }
                            </div>

                            <div className="col-12 controls">
                                { /* <span className="badges"><span className="live-badge">LIVE</span></span> */ }
                                <h3 className="vehicle-name">{this.props.vehicleName}</h3>
                                <button className="btn btn-outline-blue" onClick={this.props.onClose}><i className="material-icons">close</i>{strings.action_close}</button>
                            </div>
                        </div>
                    </div>
                    {this.state.modalContainer}
                </Modal>
        );
    }
}

class LiveStreamDownload extends PureComponent {

    static propTypes = {
        stage: PropTypes.string.isRequired,
        ravenUuid: PropTypes.string.isRequired,
        cameraType: PropTypes.string.isRequired,
        timestamp: PropTypes.number.isRequired,
        onCancel: PropTypes.func.isRequired, //dismissModalContainer
        onError: PropTypes.func.isRequired, 
        onSuccess: PropTypes.func.isRequired
    }

    constructor(props) {

        super(props);

        this.state = {
            sendPending: false
        }

    }

    onSend = () => {

        this.setState({
            sendPending: true
        });

        RcAPI.refreshTempCredentials(this.props.stage)
        .then(
            (apiJWT) => {
                RcAPI.requestBasicCreateRavenMedia(
                    this.props.stage,
                    this.props.ravenUuid,
                    this.props.cameraType,
                    this.props.timestamp - 15,  // 15 seconds prior to timestamp
                    30             // effectively, 15 seconds after timestamp
                )
                .then(
                    (body) => {
                        this.props.onSuccess();
                    },
                    (error) => {
                        return Promise.reject(error); // passed to .catch below
                    }
                )
                .catch( (error) => {
                    console.error("LiveStreamDownload requestBasicCreateRavenMedia error.", error);
                    this.props.onError();
                });
            },
            (error) => {
                return Promise.reject(error); // passed to .catch below
            }
        )
        .catch( (error) => {
            console.error("LiveStreamDownload refreshTempCredentials error.", error);
            this.props.onError();
        });
    }

    render() {

        let cameraTypeName = strings.camera_type_road_lowercase;
        if (this.props.cameraType !== "ROAD") {
            cameraTypeName = strings.camera_type_cabin_lowercase;
        }

        if (this.state.sendError) {
            return (
                <>
                    <div className="message">
                        {strings.settings_error_request_error}
                    </div>

                    <div className="actions">
                        <button onClick={this.props.onCancel} >{strings.app_ok}</button>
                    </div>
                </>
            );
        }

        if (this.state.sendSuccess) {
            return (
                <>
                    <div className="message">
                        {strings.settings_error_request_error}
                    </div>

                    <div className="actions">
                        <button onClick={this.props.onCancel} >{strings.app_ok}</button>
                    </div>
                </>
            );
        }

        // show initial prompt to send request:
        return (
            <>
                <div className="message">
                    {strings.formatString(strings.streaming_request_video_download_description, cameraTypeName)}
                </div>

                <div className="actions">
                    <button className="destructive" onClick={this.props.onCancel}>
                        {strings.action_cancel}
                    </button>

                    <div style={{position:"relative"}/* to position ProgressOverlay "relative" to this button wrapper */}>
                        <button disabled={this.state.sendPending} onClick={this.onSend} >
                            {strings.action_send}
                            {this.state.sendPending ? <ProgressOverlay /> : null }
                        </button>
                    </div>
                </div>
            </>
        );
    }

}

LiveStream.propTypes = {
    stage: PropTypes.string.isRequired,
    ravenUuid: PropTypes.string.isRequired,
    vehicleName: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    defaultCamera: PropTypes.string.isRequired,
    startDate: PropTypes.object
};

export default preloadScript(LiveStream);
